export function navigateToOAuthUrl(url: string): void {
  window.location.href = url;
}
